import { render, staticRenderFns } from "./TabPurchasePreview.view.vue?vue&type=template&id=37f8cbe6&"
import script from "./TabPurchasePreview.view.vue?vue&type=script&lang=js&"
export * from "./TabPurchasePreview.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f8cbe6')) {
      api.createRecord('37f8cbe6', component.options)
    } else {
      api.reload('37f8cbe6', component.options)
    }
    module.hot.accept("./TabPurchasePreview.view.vue?vue&type=template&id=37f8cbe6&", function () {
      api.rerender('37f8cbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/sign/TabPurchasePreview.view.vue"
export default component.exports